module.exports = __webpack_public_path__ + "img/logo-fundacion-forge-footer-color.abc2e8b5.png";